import { Box, Text, useMediaQuery, useToast } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import exportFromJSON from 'export-from-json';
import { useContext, useEffect, useState } from 'react';
import { BsFillArrowDownSquareFill } from 'react-icons/bs';
import { HiOutlineAdjustmentsHorizontal } from 'react-icons/hi2';
import { IoIosArrowDown } from 'react-icons/io';
import { IoCloseOutline } from 'react-icons/io5';

import { LupaIcon } from '../../../../../assets/icons/LupaIcon';
import FilterContext from '../../../../../contexts/FilterContext';
import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getProductName } from '../../../../../utils/leads.util';
import KanbanFiltersModal from './KanbanFiltersModal';

type handleFilterType = {
  handleFilter?: (url: string) => Promise<void>;
  login?: string;
};

function KanbanFilters({ handleFilter, login }: handleFilterType) {
  const products = [
    'Odonto',
    'Saúde',
    'Saúde PRC',
    'Saúde + Odonto',
    'Viagem',
    'VIAGEM',
    'Vida',
    'Previdência',
    'Vida Coletivo',
    'Odonto Empresa'
  ];
  const ordenacoes = ['Padrão', 'Mais recentes', 'Mais antigos'];
  const typeSearch = [
    { text: 'Nome', id: 'NOME__c' },
    { text: 'Email', id: 'EMAIL__c' },
    { text: 'Telefone', id: 'TELEFONE__c' },
    { text: 'Celular', id: 'CELULAR__c' }
  ];

  const initalFilters = {
    query: {
      status: '',
      'data-inicial': '',
      'data-final': '',
      campanha: '',
      'produto-atual': '',
      'abordagem-n2': '',
      produto: '',
      abordagem: '',
      nome: '',
      email: '',
      telefone: '',
      celular: ''
    },
    headers: {
      cpf: '',
      cnpj: ''
    }
  };

  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [loadingExportingData, setLoadingExportData] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const {
    filterObject,
    setFilterObject,
    exportObject,
    setExportObject,
    setOrderBy
  } = useContext(FilterContext);
  const [typeFilter, setTypeFilter] = useState('filtrar');
  const [selectedProduct, setSelectedProduct] = useState('Selecione');
  const [selectedOrderBy, setSelectedOrderBy] = useState('Ordenar por');
  const [selectedTextType, setSelectedTextType] = useState(typeSearch[0]);
  const [filterTextState, setFilterTextState] = useState('');
  const isMobile = useMediaQuery('(max-width: 920px)');

  const getOrderBy = async (selectedOrder) => {
    switch (selectedOrder) {
      case 'Padrão':
        return setOrderBy({ ordenacao: '', direcao: '' });
      case 'Mais recentes':
        return setOrderBy({
          ordenacao: 'DATA_ULTIMA_ALTERACAO__c',
          direcao: 'desc'
        });
      case 'Mais antigos':
        return setOrderBy({
          ordenacao: 'DATA_ULTIMA_ALTERACAO__c',
          direcao: 'asc'
        });
      default:
        return setOrderBy({ ordenacao: '', direcao: '' });
    }
  };

  const exportData = async (formatFilters) => {
    try {
      setLoadingExportData(true);
      const limit = 300;

      let cursor = '';
      let leadsExportArray = [];
      let queryStatus = '';
      const exportFormatQuery = {
        ...formatFilters.query
      };
      const exportFormatHeader = {
        ...formatFilters.headers,
        login: login ? login : null
      };

      for (const filter in exportFormatHeader) {
        if (
          exportFormatHeader[filter] === null ||
          exportFormatHeader[filter] === ''
        ) {
          delete exportFormatHeader[filter];
        }
      }

      for (const filter in exportFormatQuery) {
        if (
          exportFormatQuery[filter] === null ||
          exportFormatQuery[filter] === ''
        ) {
          delete exportFormatQuery[filter];
        }
      }
      const filterURL = '' + new URLSearchParams(exportFormatQuery).toString();

      queryStatus = `${filterURL !== '' ? filterURL : ''}`;

      let lastItem = '';

      while (cursor !== null) {
        const { data: newLeads } = await apiSensedia.get(
          `oportunidades-sulamerica/painel-leads/leads?${queryStatus}&tamanho-pagina=500${
            lastItem !== '' ? `&cursor=${lastItem}` : ''
          }`,
          {
            timeout: 0,
            headers: { ...exportFormatHeader }
          }
        );

        cursor = newLeads.proximo_cursor;
        lastItem = newLeads.proximo_cursor ? newLeads.proximo_cursor : '';
        leadsExportArray = leadsExportArray.concat(newLeads.leads);
      }

      if (leadsExportArray.length <= 0) {
        toast({
          position: 'top',
          description: 'Não existem leads com os filtros selecionados',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
        return;
      }

      const data = leadsExportArray.map((lead) => {
        return {
          id_lead: lead.ID_LEAD__c,
          id_mdm: lead.ID_MDM__c,
          data_lead: new Date(lead.CreatedDate).toLocaleDateString('pt-BR'),
          nome: lead.NOME__c,
          cpf: lead.CPF__c,
          cpnj: lead.CNPJ__c,
          telefone: lead.TELEFONE__c,
          celular: lead.CELULAR__c,
          email: lead.EMAIL__c,
          segmento: lead.SEGMENTO__c,
          mensagem: lead.MENSAGEM__c?.replace(/[\r\n]/gm, ' '),
          nome_corretor: lead.NOME_CORRETOR__c,
          EV: lead.ESTRUTURA_VENDA__c,
          codigo_produtor: lead.CODIGO_PRODUTOR__c,
          status_lead: lead.STATUS__c,
          campanha: lead.Campanha__c,
          lote: lead.LOTE__c,
          data_campanha: lead.DATA_CAMPANHA__c,
          objetivo_campanha: lead.OBJETIVO_CAMPANHA__c,
          descritivo_campanha: lead.DESCRITIVO_CAMPANHA__c,
          data_agendamento:
            lead.STATUS__c === 'NovoContato' && lead.DATA_AGENDAMENTO__c
              ? `${format(
                  new Date(lead.DATA_AGENDAMENTO__c?._seconds * 1000 || 0),
                  'dd/MM/yyyy'
                )} ás ${format(
                  new Date(lead.DATA_AGENDAMENTO__c?._seconds * 1000 || 0),
                  'HH:mm'
                )}`
              : ''
        };
      });
      const fileName = `Export-lead`;
      const exportType = exportFromJSON.types['csv'];

      exportFromJSON({ data, fileName, exportType });

      // await apiSensedia..put(
      //   `/oportunidades-sulamerica/painel-leads/registro-exportacao`
      // );
    } catch (error: any) {
      console.log(error?.response.status);
      if (error?.response.status === 406) {
        toast({
          position: 'top',
          description:
            'Lamentamos, mas não foi possível realizar a pesquisa. Por favor, diminua a quantidade de filtros selecionados e tente novamente.',
          status: 'error',
          duration: 5000,
          isClosable: true
        });
        return;
      }

      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
    } finally {
      setLoadingExportData(false);
    }
  };

  return (
    <>
      <div className="tw-w-[100%] tw-flex tw-items-center tw-justify-center tw-flex-col">
        <div className="tw-w-[90vw] mb:tw-h-[100%] mb:tw-py-4 sm:tw-py-0 sm:tw-h-[8rem] tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-flex-col tw-shadow-lg tw-mb-6">
          <div className="tw-flex sm:tw-px-[2rem] mb:tw-px-[1rem] tw-w-full tw-items-end">
            <div className="tw-flex tw-flex-col tw-w-full tw-items-start">
              <span className="tw-font-bold tw-mb-2">
                Buscar Leads{' '}
                <span className="tw-font-normal tw-text-[0.8rem] tw-text-[#001E64]">
                  (Por e-mail, nome ou telefone)
                </span>
              </span>
              <form className="tw-rounded-3xl tw-flex tw-items-end tw-justify-between tw-gap-6 tw-w-full mb:tw-flex-col sm:tw-flex-row">
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild>
                    <button
                      className="tw-pl-1 sm:tw-w-[20%] mb:tw-w-full tw-text-white tw-border-black tw-border-[0.1rem] tw-rounded-full tw-h-11 "
                      aria-label="Customise options"
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                        <span className={'tw-text-black'}>
                          {selectedTextType.text}
                        </span>
                        <IoIosArrowDown color="black" />
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="tw-px-4 tw-py-2 tw-bg-white tw-rounded-md mb:tw-w-[20rem] sm:tw-w-auto tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <DropdownMenu.Item
                        onClick={() => {
                          setSelectedProduct('Selecione o produto');
                          setSelectedTextType(typeSearch[0]);
                        }}
                        className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer mb:tw-py-1 sm:tw-py-0"
                      >
                        Selecione o tipo:
                      </DropdownMenu.Item>
                      {typeSearch.map((type, index) => {
                        return (
                          <DropdownMenu.Item
                            defaultChecked={type.id === 'NOME__c'}
                            key={index}
                            onClick={() => {
                              setSelectedProduct('Selecione o produto');
                              setSelectedTextType(type);
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer mb:tw-py-1 sm:tw-py-0"
                          >
                            {type.text}
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
                <div className="tw-flex mb:tw-w-full">
                  <div
                    className={
                      isMobile
                        ? 'tw-flex tw-items-center tw-rounded-[1.85rem_0_0_1.85rem] tw-h-11 tw-border-[0.1rem] tw-border-r-[0] tw-border-black mb:tw-w-full '
                        : 'tw-flex tw-items-center tw-rounded-[1.85rem_0_0_1.85rem] tw-h-11 tw-border-[0.1rem] tw-border-r-[0] tw-border-black mb:tw-w-full '
                    }
                  >
                    <input
                      className="tw-bg-transparent tw-w-full tw-py-[1vh] tw-px-[5px]"
                      placeholder="Buscar leads por e-mail, nome ou telefone."
                      value={filterTextState}
                      onChange={(e) => {
                        setFilterTextState(e.target.value);
                      }}
                    />
                    {filterTextState && (
                      <button
                        type={'reset'}
                        onClick={(e) => {
                          e.preventDefault();
                          // setEquipesData(originalData);
                          setFilterTextState('');
                          // handleFiltroSelect();
                        }}
                      >
                        <IoCloseOutline size="1.5rem" />
                      </button>
                    )}
                  </div>
                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      // handleFiltro();
                      filterTextState !== '' &&
                        setFilterObject({
                          ...filterObject,
                          query: {
                            ...filterObject.query,
                            nome:
                              selectedTextType.id === 'NOME__c'
                                ? filterTextState
                                : null,
                            email:
                              selectedTextType.id === 'EMAIL__c'
                                ? filterTextState
                                : null,
                            telefone:
                              selectedTextType.id === 'TELEFONE__c'
                                ? filterTextState
                                : null,
                            celular:
                              selectedTextType.id === 'CELULAR__c'
                                ? filterTextState
                                : null
                          }
                        });
                    }}
                    className={
                      isMobile
                        ? 'tw-bg-[#FF5000] tw-rounded-[0_1.85rem_1.85rem_0] tw-py-[0.925vh] tw-px-3 tw-border-[0.1rem] tw-border-l-[0] tw-border-[#001E64] '
                        : 'tw-bg-[#FF5000] tw-rounded-[0_1.85rem_1.85rem_0] tw-py-[0.3vh] 2xl:tw-w-[2.2vw] xl:tw-w-[3vw] tw-border-[0.1rem] tw-border-l-[0] tw-border-[#001E64] '
                    }
                  >
                    <LupaIcon w="1.5rem" h="1.5rem" />
                  </button>
                </div>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setFilterObject(initalFilters);
                  }}
                  className="tw-border-[0.1rem] tw-font-bold tw-text-[#AA2C23] tw-border-[#AA2C23] tw-rounded-full tw-h-11 sm:tw-w-[20%] mb:tw-w-full"
                >
                  Limpar Busca
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="tw-flex tw-justify-between tw-w-[90vw] mb:tw-flex-col md:tw-flex-row mb:tw-gap-6 sm:tw-gap-0">
          <div>
            <div className="sm:tw-w-[21.75vw] mb:tw-w-full tw-h-[10rem] tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-shadow-sm">
              <div className="tw-w-full tw-px-4">
                <div className="tw-flex">
                  <p className="tw-font-bold tw-text-[1.3rem]">Produtos</p>
                </div>
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild className="">
                    <button
                      className="tw-w-[100%] tw-pl-1 tw-text-white tw-border-black tw-border-[0.1rem] tw-rounded-full tw-min-h-[2.5rem] "
                      aria-label="Customise options"
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1rem] tw-font-bold tw-items-center tw-justify-between tw-px-2">
                        <span
                          className={
                            selectedProduct === 'Selecione'
                              ? 'tw-text-[#AAAAAA]'
                              : 'tw-text-black'
                          }
                        >
                          {selectedProduct}
                        </span>
                        <IoIosArrowDown color="black" />
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="mb:tw-w-[20rem] sm:tw-w-auto tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <DropdownMenu.Item
                        onClick={() => {
                          setSelectedProduct('Selecione');
                          setFilterObject({
                            ...filterObject,
                            query: {
                              ...filterObject.query,
                              'produto-atual': null
                            }
                          });
                        }}
                        className="hover:tw-bg-slate-200 tw-w-[100%] tw-font-bold tw-cursor-pointer mb:tw-py-1 sm:tw-py-0"
                      >
                        Selecione o produto:
                      </DropdownMenu.Item>
                      {products.map((product, index) => {
                        return (
                          <DropdownMenu.Item
                            key={index}
                            onClick={() => {
                              setSelectedProduct(product);
                              setFilterObject({
                                ...filterObject,
                                query: {
                                  ...filterObject.query,
                                  'produto-atual': product
                                }
                              });
                            }}
                            className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer mb:tw-py-1 sm:tw-py-0"
                          >
                            {getProductName(product)}
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              </div>
            </div>
          </div>
          <div>
            <div className="sm:tw-w-[21.75vw] mb:tw-w-full tw-h-[10rem] tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-flex-col tw-shadow-sm ">
              <div className="tw-w-[100%] tw-px-[1rem] tw-flex tw-justify-between tw-items-start">
                <div className="tw-flex tw-flex-col tw-justify-between tw-w-[100%]">
                  <p className="tw-font-bold tw-text-[1.3rem]">Filtrar leads</p>
                  <button
                    className="tw-bg-[#146CFA] tw-flex tw-items-center tw-text-[1.2rem] tw-justify-center tw-w-[100%] tw-h-12 tw-rounded-full tw-p-[0.5rem]"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenModal(true);
                      setTypeFilter('filtrar');
                    }}
                  >
                    <HiOutlineAdjustmentsHorizontal
                      size={'1.8rem'}
                      color={'#FFFFFF'}
                    />
                    <span className="tw-text-[white]">Filtrar leads</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="sm:tw-w-[21.75vw] mb:tw-w-full tw-h-[10rem] tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-flex-col tw-shadow-sm ">
              <div className="tw-w-[100%] tw-px-[1rem] tw-flex tw-justify-between tw-items-start">
                <div className="tw-flex tw-flex-col tw-justify-between tw-w-[100%]">
                  <p className="tw-font-bold tw-text-[1.3rem]">Ordenar leads</p>
                  <div className="tw-w-full  tw-flex tw-h-full tw-items-end">
                    <DropdownMenu.Root>
                      <DropdownMenu.Trigger asChild>
                        <button
                          className="tw-bg-[#146CFA] tw-text-[1.2rem] tw-w-[100%] tw-rounded-full tw-p-[0.5rem] tw-h-12"
                          aria-label="Customise options"
                        >
                          <span className="tw-pl-1 tw-flex tw-text-[1rem]  tw-items-center tw-justify-between ">
                            <span className={'tw-text-white'}>
                              {selectedOrderBy}
                            </span>
                            <IoIosArrowDown color="#FFFFFF" />
                          </span>
                        </button>
                      </DropdownMenu.Trigger>

                      <DropdownMenu.Portal>
                        <DropdownMenu.Content
                          className="mb:tw-w-[20rem] sm:tw-w-auto tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                          sideOffset={5}
                        >
                          <DropdownMenu.Item
                            onClick={() => {
                              getOrderBy('Selecione');
                              setSelectedOrderBy('Ordernar por');
                            }}
                            className="hover:tw-bg-slate-200 tw-font-bold tw-cursor-pointer mb:tw-py-1 sm:tw-py-0"
                          >
                            Selecione a ordenação:
                          </DropdownMenu.Item>
                          {ordenacoes.map((product, index) => {
                            return (
                              <DropdownMenu.Item
                                key={index}
                                onClick={() => {
                                  getOrderBy(product);
                                  setSelectedOrderBy(product);
                                }}
                                className="tw-w-[100%] hover:tw-bg-slate-200 tw-cursor-pointer mb:tw-py-1 sm:tw-py-0"
                              >
                                {product}
                              </DropdownMenu.Item>
                            );
                          })}
                        </DropdownMenu.Content>
                      </DropdownMenu.Portal>
                    </DropdownMenu.Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="sm:tw-w-[21.75vw] mb:tw-w-full tw-h-[10rem] tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-flex-col tw-shadow-sm">
              <div className="tw-w-[100%] tw-px-6">
                <div className="tw-flex">
                  <p className="tw-font-bold tw-text-[1.3rem]">
                    Exportar Leads
                  </p>
                </div>
                <DropdownMenu.Root modal={false}>
                  <DropdownMenu.Trigger asChild className="tw-w-[100%]">
                    <button
                      className="tw-pl-1 tw-text-white tw-bg-[#2A4E9A] tw-rounded-full tw-h-12 tw-w-[100%]"
                      aria-label="Customise options"
                      disabled={loading || loadingExportingData}
                    >
                      <span className="tw-pl-1 tw-flex tw-text-[1.2rem] tw-text-white tw-items-center tw-justify-center tw-gap-1">
                        <BsFillArrowDownSquareFill color="white" />
                        <span>
                          {!loadingExportingData ? 'Exportar' : 'Exportando...'}
                        </span>
                      </span>
                    </button>
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.Content
                      className="mb:tw-w-[20rem] sm:tw-w-auto tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                      sideOffset={5}
                    >
                      <span className="tw-font-bold">Exportar:</span>
                      <DropdownMenu.Item
                        onClick={(e) => {
                          setTypeFilter('exportar');
                          setOpenModal(true);
                        }}
                        className="hover:tw-bg-slate-200 mb:tw-py-1 sm:tw-py-0 tw-w-[100%] tw-cursor-pointer"
                      >
                        Exportar todos os leads
                      </DropdownMenu.Item>
                      <DropdownMenu.Item
                        className="hover:tw-bg-slate-200 mb:tw-py-1 sm:tw-py-0 tw-w-[100%] tw-cursor-pointer"
                        onClick={(e) => {
                          setTypeFilter('exportar');
                          setOpenModal(true);
                        }}
                      >
                        Exportar leads por filtro
                      </DropdownMenu.Item>
                    </DropdownMenu.Content>
                  </DropdownMenu.Portal>
                </DropdownMenu.Root>
              </div>
            </div>
          </div>
        </div>
      </div>
      <KanbanFiltersModal
        isOpen={openModal}
        setIsOpen={setOpenModal}
        handleExport={exportData}
        type={typeFilter}
      />
    </>
  );
}

export default KanbanFilters;
